import React from 'react'

// styles
import './FourSectionCardListItem.css'

export default function FourSectionCardListItem({ mainTitle, subTitle, leftData = [], rightData, onClick = null}) {

    return (<div className={`four-section-card-list-item ${onClick ? 'can-click' : ''}`} onClick={onClick}>
        
        <div className='four-section-card-list-item-row'>
            <div className='four-section-card-list-item-main-title'>{mainTitle}</div>
            <div className='four-section-card-list-item-sub-title'>{subTitle}</div>
        </div>

        <hr className='four-section-card-list-item-hr' />

        <div className='four-section-card-list-item-row'>
            <div>
                {
                    leftData.map((dataRow, index) => {
                        return (<div key={`dataRow-${index}`}>{dataRow}</div>)
                    })
                }
            </div>
            <div>{rightData}</div>
        </div>
    </div>)
}